import { memo } from "react";
import usePalette from "src/hooks/usePalette";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { FloatingNotificationDot } from "../NotificationDot";
import Touchable from "../Touchable";
import MiniCardContent from "./components/MiniCardContent";
import { MINI_CARD_HEIGHT, MINI_CARD_WIDTH } from "./constants";
import { MiniCardProps } from "./types";

const borderWidth = 1;
const MiniCard = ({
	content,
	fallbackContent,
	variant = "Filled",
	containerStyle,
	title,
	EmptyIcon,
	href,
	onPress,
	target,
	hasNotification,
	renderContent,
	testID,
}: MiniCardProps) => {
	const { theme } = useStyle();
	const { primary, isFallback } = usePalette();

	const hasBorder = variant === "Edit" || variant === "Empty";
	return (
		<Touchable
			href={href}
			onPress={onPress}
			target={target}
			testID={testID}
			containerStyle={[
				{
					backgroundColor:
						variant === "Empty"
							? undefined
							: isFallback
								? color.PillBackground[theme]
								: primary,
					width: MINI_CARD_WIDTH,
					height: MINI_CARD_HEIGHT,
					borderRadius: 12,
				},
				hasBorder && {
					borderWidth,
					borderColor: color.Secondary[theme],
					borderStyle: "dashed",
				},
				containerStyle,
			]}
			style={[
				{
					alignItems: "center",
					// Avoid content shift when switching to border
					position: "absolute",
					top: hasBorder ? -borderWidth : 0,
					left: hasBorder ? -borderWidth : 0,
					width: MINI_CARD_WIDTH,
					height: MINI_CARD_HEIGHT,
				},
			]}
		>
			{renderContent ? (
				renderContent(
					<MiniCardContent
						variant={variant}
						content={content}
						fallbackContent={fallbackContent}
						title={title}
						EmptyIcon={EmptyIcon}
					/>,
				)
			) : (
				<MiniCardContent
					variant={variant}
					content={content}
					fallbackContent={fallbackContent}
					title={title}
					EmptyIcon={EmptyIcon}
				/>
			)}
			{hasNotification && <FloatingNotificationDot size={12} />}
		</Touchable>
	);
};
export default memo(MiniCard);
